/** Only the two document lists can be an AB review's return destination.
 * Keep the original query (including view=default) so returning cannot restore
 * a different saved selection. Each list interprets its own filter parameters.
 */
export function orderConfirmationBackTarget(from: unknown): { to: string; label: string } {
  if (typeof from === "string" && !/[\\\u0000-\u001f\u007f]/.test(from)) {
    const path = from.match(/^(\/belege|\/auftragsbestaetigungen)(?:\?[^#]*)?$/)?.[1];
    if (path) return { to: from, label: path === "/belege" ? "Belege" : "Auftragsbestätigungen" };
  }
  return { to: "/belege", label: "Belege" };
}
